<template>
  <div id="ag-grid-demo">
    <vx-card>
      <div slot="no-body" class="flex flex-wrap items-center justify-between pl-3 pr-3">
        <div class="filters-container flex flex-wrap items-center justify-start">
            <div class="form-group has-search">
                        <span class="fa fa-search form-control-reseller-feedback"></span>
                    <input
                    @input="onQuickFilterChanged()"
                    id="quickFilter"
                    v-model="searchProduct"
                    class="filter_input_reseller form-control-reseller"
                    >
                </div>
        </div>
        <div class="buttons-container flex flex-wrap items-center justify-end pb-3">
          <vs-button
            class="mt-3"
            @click="$router.push({ name: 'admin-reseller-add-manual-payment' })"
          >Add Manual Payment</vs-button>
          <vs-button
            class="mt-3 ml-3"
            @click="$router.push({ name: 'admin-reseller-add' })"
          >Add Reseller</vs-button>
        </div>
      </div>
    </vx-card>
    <vx-card>
      <!-- Per Page -->
      <div class="mb-4 md:mb-0">
        <per-page
          :currentPerPage="per_page"
          :pageStart="pageStart"
          :pageEnd="pageEnd"
          :total="total"
          @change-per-page="ChangePerPage($event)"
        />
      </div>

      <!-- Table -->
      <ag-grid-vue
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="list"
        @gridReady="GridReady"
        @filterChanged="Filtering"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="isFloatingFilter"
        :pagination="true"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        >
      </ag-grid-vue>

      <!-- Pagination -->
      <vs-pagination
        :total="totalPages"
        :max="maxPageNumbers"
        v-model="Page" />
    </vx-card>
  </div>
</template>

<script>
// Mixins
import TableMixin from '@/mixins/table.js'

// Packages
import { format } from 'date-fns'
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'

// Cell Renderer components
import CellRendererActions from './cell-renderer/CellRendererActions'
import CellRendererStatus from './cell-renderer/CellRendererStatus'

export default {
  mixins: [TableMixin],
  components: {
    AgGridVue,

    //Cell Renderer components
    CellRendererActions,
    CellRendererStatus
  },
  data() {
    return {
      // table header value
      columnDefs: [
        {
          headerName: 'Reseller Name',
          field: 'reseller_name',
          minWidth: 260,
          filter: true,
          cellRendererFramework: 'CellRendererStatus'
        },
        {
          headerName: 'Balance',
          field: 'balance',
          minWidth: 120
        },
        {
          headerName: 'Clients',
          field: 'clients_count',
          minWidth: 120
        },
        {
          headerName: 'Member since',
          field: 'created_on',
          minWidth: 200
        },
        {
          headerName: 'Action',
          width: 185,
          flex: 0,
          cellRendererFramework: 'CellRendererActions'
        }
      ],

      // Cell Renderer components
      components: {
        CellRendererActions,
        CellRendererStatus
      },
      searchProduct: '',
      per_page: 10,
      order_by: 'created_on',
      order_dir: 'desc',
      page:0,
    }
  },
  created() {
    this.GetList()
  },
  methods: {
    totalPages () {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    GetFilteredList() {
      const GetList = {
        page: 0,
        per_page: this.per_page || 10,
        order_by: this.order_by || 'created_on',
        order_dir: this.order_dir || 'desc',
        reseller_name: this.searchProduct + "**"
      }
      this.$store.dispatch('reseller/GetFilteredList', GetList)
        .then(res => {
          this.list = res.items.map(this.TransformReseller)
          this.total = res.total
        })
        .catch()
        .finally(() => {
          this.$vs.loading.close()
        })
    },
    GetList() {
      // this.$vs.loading()
      const GetList = {
        page: this.page || 0,
        per_page: this.per_page || 10,
        order_by: this.order_by || 'created_on',
        order_dir: this.order_dir || 'desc',
        reseller_name: this.searchProduct
      }

      this.$store.dispatch('reseller/GetList', GetList)
      .then(res => {
        this.list = res.items.map(this.TransformReseller)
        this.total = res.total
      })
      .catch()
      .finally(() => {
        this.$vs.loading.close()
      })
    },
    TransformReseller(item) {
      return {
        refreshData: this.GetList,
        reseller_uuid: item.reseller_uuid,
        status: item.status === 'active' ? true : false,
        reseller_name: item.reseller_name,
        balance: '',
        clients_count: item.clients_count,
        created_on: format(new Date(item.created_on), 'yyyy:MM:dd HH:mm:ss'),
      }
    },
    onQuickFilterChanged() {
      this.GetFilteredList()
    },
  }
}
</script>
<style>
    .filter_input_reseller{
        padding: 17px;
        padding-left: 55px;
        width: 300px;
        border: 1px solid #f5f5f5;
        font-size: 13px;
        color: gray;
        background-repeat: no-repeat;
        background-position: left center;
        outline: 0;
    }
    .has-search .form-control-reseller-feedback {
        position: absolute;
        z-index: 2;
        display: block;
        width: 15px;
        height: 15px;
        line-height: 2.375rem;
        text-align: center;
        pointer-events: none;
        color: gray;
        margin-left: 35px;
        margin-top: 20px;
    }
</style>
